import createGraphqlClient from "@/utils/apollo";

export default createGraphqlClient("hr");
